import axios from 'axios'
import config from '../config'

const getCouponDetailApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}coupon/${params.id}`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json"
        }
    })

    return response

}

export default getCouponDetailApi